import React from "react";

import TenancyDetailContent from "./TenancyDetailContent";

/**
 * The tenancy detail as a permanent right-hand column (desktop).
 *
 * On a wide screen an overlay is the wrong primitive: reading one contract and
 * scanning the list are the same task, and a drawer forces the reader to close
 * one to see the other. Below `lg` this column is hidden and
 * `TenancyDetailDrawer` takes over — the same split `BexioSyncRunDetailPanel`
 * uses, at the same breakpoint.
 *
 * The body is `TenancyDetailContent`, exactly as the drawer renders it. This
 * file contributes the frame and the sticky behaviour, and no field of its own.
 *
 * Sticky from `lg` up: the admin shell's own top bar is `lg:hidden`, so on the
 * widths where this column exists there is no fixed header for it to slide
 * under.
 *
 * THE WIDTH IS A SHARE, NOT A NUMBER. It was `420px`/`480px`, which on a 1440
 * screen is 34% — a sidebar the list happens to sit next to, not half a
 * master/detail workspace. A percentage keeps the balance at every width; the
 * min stops it collapsing at `lg`, and the max stops it turning into a page of
 * its own on an ultrawide. The seven-tab bar is what sets the lower bound:
 * below roughly 380px of column it cannot show even half its tabs.
 */
export default function TenancyDetailPanel({
  tenancy,
  loading,
  error,
  onRetry,
  onClose,
  onCancelled,
}) {
  return (
    <aside
      aria-label="Mietverhältnis-Details"
      data-testid="tenancy-detail-panel"
      className="hidden lg:sticky lg:top-6 lg:block lg:w-[40%] lg:min-w-[380px] lg:max-w-[600px] lg:shrink-0 lg:self-start xl:w-[43%] xl:max-w-[660px]"
    >
      {/* The frame is the WORKSPACE, so it must not wear the same skin as
          the cards inside it — `bg-card` on both made every panel read as a
          card holding cards. A muted ground lets the cards sit ON something
          instead of in something the same colour. */}
      <div className="rounded-[12px] border border-border bg-muted/25 p-4">
        <TenancyDetailContent
          tenancy={tenancy}
          loading={loading}
          error={error}
          onRetry={onRetry}
          onClose={onClose}
          onCancelled={onCancelled}
        />
      </div>
    </aside>
  );
}
